import { useEffect, useState } from 'react';
import { DmdillyProvider, DmdillyPage } from './components';
import { fetchProfileData } from '../utils';
import GuideDashboardHeader from '../GuideDashboardHeader';

import './index.css';

export default function App() {

  const [guideProfile, setGuideProfile] = useState(null);

  useEffect(() => {
    // Fetch profile data on app load
    fetchProfileData()
      .then(profile => {
        setGuideProfile(profile);
      })
      .catch(error => {
        console.error("Error fetching profile data:", error);
      });
  }, []);

  return (
    <DmdillyProvider
      apiBaseUrl={process.env.REACT_APP_API_URL}
      guideInfo={guideProfile ? guideProfile.guide : null} // Pass entire guide object as guideInfo
      creatorId={guideProfile ? guideProfile.guide._id : null} // Pass guide ID as creatorId to the provider
    >
      <GuideDashboardHeader />
      <DmdillyPage />
    </DmdillyProvider>
  );
}
